import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import Button from "../../components/Button";
import SearchInput from "../../components/SearchInput";
import DataTable, { type Column } from "../../components/DataTable";
import Pagination from "../../components/Pagination";
import Badge from "../../components/Badge";
import { useParcoursList } from "../../../hooks/useParcoursList";
import { useDeleteParcours } from "../../../hooks/useDeleteParcours";
import type { ParcoursResponse } from "../../../api/parcoursApi";

export default function ParcoursListPage() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const { data, isLoading } = useParcoursList({ search, page, size: 20, sort: "createdAt,desc" });
  const remove = useDeleteParcours();

  const onDelete = (id: string) => {
    if (window.confirm("Supprimer définitivement ce parcours ?")) {
      remove.mutate(id);
    }
  };

  const columns: Column<ParcoursResponse>[] = [
    {
      key: "title",
      header: "Titre",
      render: (row) => (
        <Link to={`/admin/parcours/${row.id}`} className="bo-cell-link">
          {row.title}
        </Link>
      ),
    },
    { key: "commune", header: "Commune", render: (row) => row.mainCommune ?? "—" },
    {
      key: "paid",
      header: "Visibilité",
      render: (row) =>
        row.paid ? <Badge tone="success">Payant — public</Badge> : <Badge tone="neutral">Gratuit — restreint</Badge>,
    },
    { key: "artists", header: "Artistes", render: (row) => row.artists?.length ?? 0 },
    { key: "lieux", header: "Lieux", render: (row) => row.lieux?.length ?? 0 },
    {
      key: "actions",
      header: "",
      render: (row) => (
        <div className="bo-row-end">
          <Button variant="ghost" onClick={() => navigate(`/admin/parcours/${row.id}`)}>
            Éditer
          </Button>
          <Button variant="ghost" onClick={() => onDelete(row.id)}>
            Supprimer
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <PageHeader
        title="Parcours"
        description="Liste de tous les parcours du tenant."
        actions={
          <Button variant="primary" onClick={() => navigate("/admin/parcours/new")}>
            + Nouveau parcours
          </Button>
        }
      />

      <div className="bo-toolbar">
        <SearchInput
          value={search}
          onChange={(v) => {
            setSearch(v);
            setPage(0);
          }}
          placeholder="Rechercher par titre, description, commune…"
        />
      </div>

      <DataTable
        rows={data?.content}
        columns={columns}
        rowKey={(r) => r.id}
        loading={isLoading}
        emptyMessage="Aucun parcours pour le moment."
      />
      <Pagination page={page} totalPages={data?.totalPages ?? 0} onChange={setPage} />
    </div>
  );
}
